import type { FaireProductEntity } from "../../entity_types/product";

export const p_d9gc6d3z2m: FaireProductEntity = {
  token: "p_d9gc6d3z2m",
  type: "product",
  name: "Unisex Kids Toddler Youth Long Sleeve Pullover T-shirt - DIY",
  brandToken: "b_58wn0038",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3bce945e1ea331a90691a18b3982a85a02cd64a6961eeff2005f4fdc095f325d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0608e41a7da0f5c598792618b27a89074cd31cc934db747ec2253f97aed2712.png",
    "https://cdn.faire.com/fastly/57a13d6d0876ff7da0ea299913c7a1c14d34fe1610c980a006c0f7fab243a094.jpeg",
    "https://cdn.faire.com/fastly/122dbd018038f6eb45e01e985cd2c8bec8c51a3d273ff07e9378155f9b68a232.jpeg",
    "https://cdn.faire.com/fastly/41f69553e9e114400ff2699c558ddad14125cdc84d70dd0d9c3723ffce80fe81.jpeg",
    "https://cdn.faire.com/fastly/ae0ce56f16226427766ff00c4d41b460738408916033c0ecacf16b3d13362446.jpeg",
    "https://cdn.faire.com/fastly/75614481905dcef42348655da374f88b60a135a7194fc8b2e7f53df7bdd69dcd.jpeg",
    "https://cdn.faire.com/fastly/a0e3dabdc2381584b510bda850ef8896ede5aee2a46f874de27710495c85a4b2.png",
  ],
  priceDollars: 13.86,
  description:
    "Polyester blend pullovers for sublimation. Please note these are lightweight and thinner than a sweatshirt. Sublimates with a retro/vintage look due to the 35% cotton blend. Ready for your next DIY project with its buttery soft feel. \n\nNo minimum! \n\nFEATURES:\n➼ Double-needle stitched sleeves and bottom hems. \n➼ Top stitched ribbed crew neck for easy dressing.\n➼ Moisture-wicking fabric that helps to keep cool and dry. \n\nIdeal For: Custom Gifts, DIY Projects, Personalized Gifts, I'm Going To Be a Big Sister Pregnancy Announcement, I'm Going To Be a Big Brother Pregnancy Announcement, Birthday Parties, Theme Park Shirts, Family Pictures, Valentine’s Day, St. Patrick's Day, Easter, Halloween, Christmas, New Years, Thanksgiving, 4th of July, Summer Nights, Fall, Autumn, Pumpkin Patches, Beach Days, Hay Rides, Spring. \nPersonalize these t-shirts with your child's initials, name or nickname.\n\nWe are The Laughing Giraffe based out of sunny So Cal. Sweatshop free & CPSIA compliant.",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:25.393Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
